import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
export class ARGpsAttribute extends AbstractBlock {
  constructor() {
    super('ar-gpsatt', t.to('ARロケーション指定', 'ar_location'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setARColor(block);

    const latitude = new Blockly.FieldTextInput('35.645030399999996');
    const longitude = new Blockly.FieldTextInput('139.7293056');
    block
      .appendDummyInput()
      .appendField(t.to('経度', 'latitude'))
      .appendField(latitude, 'latitude')
      .appendField(t.to('緯度', 'longitude'))
      .appendField(longitude, 'longitude');

    // ShapeSettings.setTitleField(block,this.title);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const longitude = CodeSetting.getFieldValue(block, 'longitude');
    const latitude = CodeSetting.getFieldValue(block, 'latitude');

    const attribute = CodeSetting.getSubAttributeCode(block);
    const str =
      CodeSetting.getAttributeCode(
        'gps-entity-place',
        `latitude: ${latitude}; longitude: ${longitude};`
      ) + attribute;
    return [str];
  }
}
